import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { dropdownValues } from '@interfaces/common.model';
import { ToasterService } from '@services/toaster.service';
import { TeamManagementService } from '../team-management.service';
import { ApiStatus } from '@constants/global.enum';

@Component({
  selector: 'app-new-beginnings',
  templateUrl: './new-beginnings.component.html',
  styleUrl: './new-beginnings.component.scss',
})
export class NewBeginningsComponent implements OnInit {
  @Output() requestCreated = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  @Input() employeeDetails: any;

  newBeginningsForm!: FormGroup;
  newBeginningsOptions: dropdownValues[] = [
    {
      label: 'Marriage',
      value: 'Marriage',
    },
    {
      label: 'New Born Baby',
      value: 'New Born Baby',
      selected: false,
    },
  ];

  constructor(
    private teamManagementService: TeamManagementService,
    private toaster: ToasterService,
  ) {}

  ngOnInit(): void {
    this.newBeginningsForm = new FormGroup({
      employeeName: new FormControl(
        this.employeeDetails?.name || '',
        Validators.required,
      ),
      psid: new FormControl(
        this.employeeDetails?.psId || '',
        Validators.required,
      ),
      email: new FormControl(
        this.employeeDetails?.email || '',
        Validators.required,
      ),
      eventType: new FormControl('', Validators.required),
      message: new FormControl('', Validators.required),
    });
  }

  onClose(): void {
    this.close.emit();
  }

  onSubmit(): void {
    if (this.newBeginningsForm.invalid) {
      this.newBeginningsForm.markAllAsTouched();
      this.toaster.showError('Please fill all the required fields', 'Error');
      return;
    }
    this.teamManagementService
      .createNewBeginning({
        ...this.newBeginningsForm.value,
        eventType: this.newBeginningsForm.value.eventType?.value,
      })
      .subscribe({
        next: (response) => {
          this.toaster.showSuccess('Event created successfully', ApiStatus.SUCCESS);
          this.newBeginningsForm.reset();
          this.requestCreated.emit();
        },
        error: (error) => {
          this.toaster.showError(
            'Failed to submit. Please try again later',
            ApiStatus.ERROR,
          );
        },
      });
  }
}
